import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import Towerscourtacording from '../towerscourtacording/towerscourtacording.vue'
import EnterpriseUnityRepository from '@/shared/http/repositories/realestate/enterpriseunity'
import { loading } from '@/shared/utils/UIHelper'
import Colapsetower from '../colapsetower/colapsetower.vue'
import UnityPriseRepository from '@/shared/http/repositories/realestate/unitytype'
export default {
  name: 'Towerscourt',
  components: {HeadDetailsGama, Towerscourtacording, Colapsetower},
  props: ['dataTowers'],
  data () {
    return {
      changeAngel: false,
      dataGroup: [],
      dataUnity: [],
      enumStatus: [],
      dataType: []
    }
  },
  mounted () {
    this.loadAll()
  },
  methods: {
    getAllGroup () {
      loading.push()
      EnterpriseUnityRepository.GetAllGroupByEmpreendimento(this.dataTowers.id)
        .then(Response => {
          this.dataGroup = Response.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    loadAll () {
      this.getAllGroup()
      this.getAllUnidade()
      this.getAllStatus()
      this.GetAllType()
    },
    getAllUnidade () {
      loading.push()
      EnterpriseUnityRepository.GetAllWithTipoByEmpreendimentoId(this.dataTowers.id)
        .then(Response => {
          this.dataUnity = Response.data.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    getAllStatus () {
      loading.push()
      EnterpriseUnityRepository.GetAllStatus()
        .then(Response => {
          this.enumStatus = Response.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    },
    GetAllType () {
      loading.push()
      UnityPriseRepository.GetAllByEmpreendimento(this.dataTowers.id)
        .then(Response => {
          this.dataType = Response.data.data
          loading.pop()
        })
        .catch(Error => loading.pop())
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/private/realestate/enterprise/components/towerscourt/towerscourt.js